import React from 'react';
import { Typography, TextField, Alert } from '@mui/material';

/**
 * CustomSection Component
 *
 * Displays the custom CSS section in the theme customizer.
 *
 * @param {Object} props
 * @param {Object} props.themeData - Current theme data object
 * @param {Function} props.updateThemeData - Function to update theme data
 */
function CustomSection({ themeData, updateThemeData }) {
  return (
    <>
      <Typography variant="h6" gutterBottom>
        Custom CSS
      </Typography>
      <Alert severity="info" sx={{ mb: 2 }}>
        Add custom CSS to further customize your theme. This will be applied
        globally.
      </Alert>

      <TextField
        label="Custom CSS"
        multiline
        rows={10}
        value={themeData.custom_css || ''}
        onChange={e => updateThemeData('custom_css', e.target.value)}
        helperText="Enter custom CSS rules"
        margin="normal"
        fullWidth
        sx={{ fontFamily: 'monospace' }}
      />
    </>
  );
}

export default CustomSection;
